import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      prefix: props.prefix || '',
      data: null,
      name: '',
      success_url: '',
      err_msg: '',
      open: false
    }

    this.handle_cancel = this.handle_cancel.bind(this)
    this.handle_submit = this.handle_submit.bind(this)
    this.open_confirm = this.open_confirm.bind(this)
  }

  open_confirm(data, name, success_url) {
    this.setState(
      {data: data, name: name, open: true, success_url: success_url}
    )
  }

  handle_cancel(e) {
    this.setState(
      {open: false}
    )
  }

  handle_submit(e) {
    var self = this
    const success_url = this.state.success_url
    this.props.handle_confirm(this.state.data, (err) => {
      if (err) {
        self.setState(
          {err_msg: err.message}
        )
      }
      else {
        self.setState(
          {open: false}, () => {
            this.props.history.replace(success_url, {test: false})
          }
        )
      }
    })
  }

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        onClick={this.handle_cancel}
      />,
      <FlatButton
        label={this.props.confirm_text}
        keyboardFocused={true}
        onClick={this.handle_submit}
      />,
    ]
    return (
      <Dialog
        open={this.state.open}
        title={this.state.prefix + ' ' + this.state.name + ' ?'}
        modal={true}
        actions={actions}
      >
        <div>{this.state.err_msg}</div>
      </Dialog>
    )
  }
}

ConfirmDialog.defaultProps = {
  prefix: '',
  confirm_text: 'Confirm',
  handle_confirm: null,
  history: null
}

export default ConfirmDialog



// WEBPACK FOOTER //
// ./src/widgets/confirm_dialog.react.js